/**
 * Wires the single `#confirmation-popup` markup shared by every page (see
 * `_footer.html`) instead of each caller duplicating the same show/cleanup
 * dance for its own destructive action.
 */
export function showConfirmation(title, message, onConfirm) {
	const popup = document.querySelector("#confirmation-popup");
	if (!popup) return;

	const titleEl = popup.querySelector("#confirmation-title");
	const messageEl = popup.querySelector("#confirmation-message");
	const cancelBtn = popup.querySelector(".cancel");
	const confirmBtn = popup.querySelector(".confirm");

	if (titleEl) titleEl.textContent = title;
	if (messageEl) messageEl.textContent = message;

	popup.classList.add("show");

	const cleanup = () => {
		confirmBtn.onclick = null;
		cancelBtn.onclick = null;
		popup.classList.remove("show");
	};

	confirmBtn.onclick = () => {
		onConfirm();
		cleanup();
	};

	cancelBtn.onclick = () => {
		cleanup();
	};
}
